import { useEffect } from 'react';

/**
 * Subscribes a callback to the cross-tab `storage` event plus an optional
 * same-tab custom event (or list of events). Calls the callback whenever
 * either fires, so callers can re-read localStorage and update local state.
 *
 * Replaces the duplicated `useEffect(() => addEventListener('storage', ...);
 * addEventListener('itow-X-changed', ...))` boilerplate in `useFavoritesCount`,
 * `useFavorite`, and `useRecentItems` (slice 660).
 */
export function useStorageSync(
  customEventName: string | string[],
  callback: () => void,
): void {
  useEffect(() => {
    const events = Array.isArray(customEventName) ? customEventName : [customEventName];
    window.addEventListener('storage', callback);
    for (const name of events) window.addEventListener(name, callback);
    return () => {
      window.removeEventListener('storage', callback);
      for (const name of events) window.removeEventListener(name, callback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, Array.isArray(customEventName) ? customEventName.join(',') : customEventName]);
}
